const normalizeStringEnv = (value?: string) => {
  if (typeof value !== 'string') return undefined
  const normalized = value.trim()
  return normalized || undefined
}

const normalizeVersion = (value?: string) => {
  const normalized = normalizeStringEnv(value)
  if (!normalized) return 'v0.0.0'
  return normalized.startsWith('v') ? normalized : `v${normalized}`
}

const normalizeBooleanEnv = (value?: string) => {
  if (typeof value !== 'string') return undefined
  const normalized = value.trim().toLowerCase()
  if (!normalized) return undefined
  if (['true', '1', 'yes', 'on'].includes(normalized)) return true
  if (['false', '0', 'no', 'off'].includes(normalized)) return false
  return undefined
}

export const VERSION_APP = normalizeVersion(process.env.REACT_APP_VERSION)

const backendUrl = normalizeStringEnv(process.env.REACT_APP_BACKEND_URL)

if (!backendUrl) {
  throw new Error('Missing REACT_APP_BACKEND_URL')
}

export const BACKEND_URL = backendUrl

const rawFeatureShowGoogleIntegration = normalizeBooleanEnv(
  process.env.REACT_APP_FEATURE_SHOW_GOOGLE_INTEGRATION,
)

export const FEATURE_SHOW_GOOGLE_INTEGRATION =
  rawFeatureShowGoogleIntegration ?? false

export const GOOGLE_CLIENT_ID =
  normalizeStringEnv(process.env.REACT_APP_GOOGLE_CLIENT_ID) || ''

export const RING_CENTRAL_CLIENT_ID =
  normalizeStringEnv(process.env.REACT_APP_RING_CENTRAL_CLIENT_ID) || ''

export const RING_CENTRAL_APP_SERVER =
  normalizeStringEnv(process.env.REACT_APP_RING_CENTRAL_APP_SERVER) || ''
